import { c as _c } from "react/compiler-runtime";
import React from "react";
const flagMap = {
  "en-us": "us",
  "en-sg": "sg",
  "zh-tw": "tw",
  "ja-jp": "jp",
  "zh-hk": "hk",
  "ko-kr": "kr",
  "en-ph": "ph",
  "en-th": "th",
  "en-gb": "gb",
  "en-in": "in",
  "en-sl": "sl",
  "en-za": "za",
  "en-au": "au",
  "en-ke": "ke",
  "en-kw": "kw",
  "ms-my": "my",
  "en-nz": "nz",
  "en-sa": "sa",
  "en-tr": "tr",
  "uk-ua": "ua",
  "en-ae": "ae",
  "en-ca": "ca",
  "hu-hu": "hu",
  "de-at": "at",
  "en-rs": "rs",
  "de-ch": "ch",
  "de-de": "de",
  "en-il": "il",
  "bg-bg": "bg",
  "fr-fr": "fr",
  "it-it": "it",
  "da-dk": "dk",
  "sk-sk": "sk",
  "no-no": "no",
  "en-ie": "ie",
  "es-es": "es",
  "hr-hr": "hr",
  "pl-pl": "pl",
  "lt-lt": "lt",
  "ro-ro": "ro",
  "lv.lv": "lv",
  "nl-nl": "nl",
  "ru-ru": "ru",
  "nl-be": "be",
  "cs-cz": "cz",
  "el-gr": "gr",
  "pt-pt": "pt",
  "sv-se": "se",
  "es-mx": "mx",
  "pt-br": "br",
  "fi-fi": "fi",
  "zh-cn": "cn",
  "en-id": "id",
  "es-ar": "ar",
  "es-cl": "cl"
};
const Numflag = t0 => {
  const $ = _c(2);
  const {
    country_ext
  } = t0;
  const flagClass = flagMap[country_ext];
  if (!flagClass) {
    return null;
  }
  const t1 = `gss_img flag-${flagClass}`;
  let t2;
  if ($[0] !== t1) {
    t2 = <span className="phoneflag absolute top-8 left-3"><b className={t1} /></span>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};
export default Numflag;